import _ from "../../../../../lib/lodash.custom.min";

export default {
	basicCondition: _.template(require("raw!./basic-condition.template.html")),
	detailCondition: _.template(require("raw!./detail-condition.template.html")),
	pagerTop: _.template(require("html!./pager-top.template.html")),
	pagerBottom: _.template(require("html!./pager-bottom.template.html")),
	currentConditions: _.template(require("html!./currentConditions.template.html")),
	ranking: _.template(require("raw!./ranking.template.html")),
	courseCalendar: _.template(require("html!./course-calendar.template.html")),
	region: _.template(require("html!./region.template.html")),
	country0: _.template(require("html!./country0.template.html")),
	country1: _.template(require("html!./country1.template.html")),
	city0: _.template(require("html!./city0.template.html")),
	city1: _.template(require("html!./city1.template.html")),
	calendarBase: _.template(require("html!./calendar-base.template.html")),
	calendarCheckbox: _.template(require("raw!./calendar-checkbox.template.html")),
	calendarMonth: _.template(require("html!./calendar-month.template.html")),
	departure: _.template(require("html!./departure.template.html")),
	duration: _.template(require("html!./duration.template.html")),
	budget: _.template(require("html!./budget.template.html")),
	kodawari: _.template(require("html!./kodawari.template.html")),
	reviewHotels: _.template(require("html!./reviewHotels.template.html")),
	reviewValue: _.template(require("html!./review-value.template.html")),
	reviewPage: _.template(require("html!./review-page.template.html")),
	hotelListErrorPage: _.template(require("html!./hotelListError.template.html"))
};



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/templates/index.js